import { ArrowUp, MessageCircle, Instagram } from "lucide-react";
import Logo from "@/components/Logo";
import { TikTokIcon } from "@/components/Shared";
import { scrollToTop } from "@/lib/scroll";

const SOCIALS = [
  { icon: MessageCircle, label: "WhatsApp", href: "https://wa.me/message/GRQ25AXPDY2EI1", testid: "footer-social-whatsapp" },
  { icon: Instagram, label: "Instagram", href: "https://www.instagram.com/btdesign.digital", testid: "footer-social-instagram" },
  { icon: TikTokIcon, label: "TikTok", href: "https://www.tiktok.com/@auvixtech", testid: "footer-social-tiktok" },
];

export default function Footer() {
  return (
    <footer data-testid="footer-section" className="relative overflow-hidden border-t hairline bg-ink2/50">
      <div className="container-x pt-20">
        <div className="flex flex-col justify-between gap-12 md:flex-row">
          <div className="max-w-xs">
            <Logo onClick={scrollToTop} />
            <p className="mt-6 text-sm leading-relaxed text-sub">
              An independent digital studio in South Africa, building modern
              websites and solving everyday IT problems for businesses of every
              size.
            </p>
            <div className="mt-7 flex gap-3">
              {SOCIALS.map(({ icon: Icon, href, label, testid }) => (
                <a
                  key={label}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={label}
                  data-testid={testid}
                  className="flex h-10 w-10 items-center justify-center rounded-full border hairline bg-white/[0.03] text-sub transition-colors duration-300 hover:border-cy/50 hover:text-cy"
                >
                  <Icon className="h-4 w-4" />
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div
        data-testid="footer-logo-watermark"
        aria-hidden="true"
        className="pointer-events-none mt-16 select-none text-center font-grotesk text-[15vw] font-bold leading-[0.78] tracking-tight text-white/[0.035]"
      >
        BT·DESIGN
      </div>

      <div className="border-t hairline">
        <div className="container-x flex flex-col items-center justify-between gap-4 py-6 sm:flex-row">
          <p className="font-mono text-[10px] uppercase tracking-[0.18em] text-sub/60">
            © {new Date().getFullYear()} BT·DESIGN
          </p>
          <button
            type="button"
            onClick={scrollToTop}
            data-testid="footer-back-to-top"
            aria-label="Back to top"
            className="flex h-10 w-10 items-center justify-center rounded-full border hairline bg-white/[0.03] text-sub transition-colors duration-300 hover:border-cy/50 hover:text-cy"
          >
            <ArrowUp className="h-4 w-4" />
          </button>
        </div>
      </div>
    </footer>
  );
}
